






import { Component, Vue, Prop } from "vue-property-decorator";
import { DualNodeScheme, SchemeProgress } from "@foxone/api/src/models/defi";

@Component
class DualNodeAvaliableState extends Vue {
  @Prop() scheme!: DualNodeScheme;

  get meta() {
    const { master_surplus, slave_asset, master_asset, progress } = this.scheme;
    const assets = [slave_asset];
    if (master_surplus) {
      assets.push(master_asset);
    }

    let text = "";
    if (progress === SchemeProgress.OPENING) {
      text = this.$t("defi.dualnode.avaliable-assets", {
        assets: assets.map(x => x.symbol).join(",")
      }) as string;
    }

    return {
      text
    };
  }
}
export default DualNodeAvaliableState;
